import React from "react";
import { FileText, Download } from "lucide-react";
import { useApp } from "../../context/AppContext";
import { Reveal, Kicker } from "../motion";

export function Reporting({ hideIntro = false }) {
  const { c } = useApp();
  const r = c.reporting;

  return (
    <section id="reporting" data-testid="reporting-section" className="relative bg-[#eef2f7] py-24 md:py-32">
      <div className="mx-auto max-w-[1240px] px-5 md:px-8">
        {!hideIntro && <Reveal className="max-w-2xl">
          <Kicker>{r.kicker}</Kicker>
          <h2 className="mt-5 font-display text-4xl font-bold tracking-tight text-[#0a1a2e] sm:text-5xl">
            {r.title}
          </h2>
          <p className="mt-4 text-base text-[#3e516a] md:text-lg">{r.subtitle}</p>
        </Reveal>}

        <div className="mt-12 overflow-hidden rounded-3xl border border-black/5 bg-white">
          {r.docs.map((doc, i) => (
            <Reveal
              key={doc.name}
              delay={i * 0.05}
              as="div"
              className="group flex items-center gap-4 border-b border-[#002355]/8 px-6 py-5 transition-colors duration-300 last:border-b-0 hover:bg-[#002355]/[0.03] md:px-8"
            >
              <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-[#002355]/8 text-[#002355]">
                <FileText size={20} strokeWidth={1.7} />
              </div>
              <div className="min-w-0 flex-1">
                <p className="truncate font-display text-base font-semibold text-[#0a1a2e] md:text-lg">
                  {doc.name}
                </p>
                <p className="text-xs uppercase tracking-wide text-[#3e516a]/70">{doc.meta}</p>
              </div>
              <a
                href={doc.href}
                download
                target="_blank"
                rel="noopener noreferrer"
                data-testid={`report-download-${i}`}
                className="inline-flex items-center gap-2 rounded-full border border-[#002355]/15 px-4 py-2 text-sm font-semibold text-[#002355] transition-colors duration-300 hover:border-transparent hover:bg-[#e8a93d] hover:text-[#002355]"
              >
                <Download size={16} />
                <span className="hidden sm:inline">{c.cta.download}</span>
              </a>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
